import { render, staticRenderFns } from "./monaco.vue?vue&type=template&id=4b38f03d&"
import script from "./monaco.vue?vue&type=script&lang=js&"
export * from "./monaco.vue?vue&type=script&lang=js&"
import style0 from "./monaco.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports